export const comments_3750239 = {"data":{"data":[],"links":{}}}